(function () {
  if (!window.matchMedia('(hover: hover)').matches) return;

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var media = e.target.closest('.card__media');
    if (!media) return;
    var video = media.querySelector('.card__hover-video');
    if (!video) return;
    if (!video.src && video.dataset.src) video.src = video.dataset.src;
    video.classList.add('is-playing');
    var p = video.play();
    if (p) p.catch(function () {});
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var media = e.target.closest('.card__media');
    if (!media) return;
    if (e.relatedTarget && media.contains(e.relatedTarget)) return;
    var video = media.querySelector('.card__hover-video');
    if (!video) return;
    video.classList.remove('is-playing');
    video.pause();
    video.currentTime = 0;
  });
})();